module.exports = __webpack_public_path__ + "static/media/instruction-coin.78c77516.png";